<template>
  <div>
    <nav-breadcrumb :menu="[{label: '待审核列表'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <el-tabs v-model="applicationStatus">
          <el-tab-pane label="待审核" name="Pending Approval" />
          <el-tab-pane label="审核不通过" name="Rejected" />
        </el-tabs>
        <div class="xzpadd10">
          <data-table
            :tableData="listData"
            :columns="CustomerApplyingVehicleMortgageListColumns"
            :pageSize.sync="pageSize"
            :page.sync="page"
            :filters.sync="filters"
          ></data-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import Status2CN from "../../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import channelOptions from "../../../utils/channelOptions";

  export default {
    data() {
      return {
        applicationStatus: 'Pending Approval',
        page: 1,
        pageSize: 10,
        listData: {},
        roleData:{},
        filters: {
              form: {
                ix__channel: '',
                c__applicationDate: [],
              },
              columns: [
                {
                  label: '客户渠道',
                  component: 'el-select',
                  field: 'ix__channel',
                  options: channelOptions,
                  span: 10
                },
                {
                  label: '导入日期',
                  component: 'date-range-picker',
                  field: 'm__applicationDate',
                  op: ['gteq', 'lteq'],
                  span: 14
                }
              ],
              onSubmit:()=>{
                this.page = 1
                this.getApplyingVehicleMortgageCustomerList()
              }
        },
      }
    },
    computed : {
      CustomerApplyingVehicleMortgageListColumns: function() {
        return [
          {
            name: '客户姓名',
            field: 'c__customerName'
          },
          {
            name: '手机号',
            field: 'i__contactTelNo'
          },
          {
            name: '身份证号码',
            field: 'i__socialIdentityCode'
          },
          {
            name: '获客渠道',
            field: 'ix__channel'
          },
          {
            name: '联系人手机',
            field: 'i__contactTelNo'
          },
          {
            name: '导入时间',
            field: 'm__applicationDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm')
            }
          },
          {
            name: '状态',
            field: 'm__applicationStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            name: '操作',
            opts: [
              {
                label: '抵押审查',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomer(index, row)
                },
                conditions: row=> row.m__applicationStatus=='Pending Approval'&&row.t__roleId==this.roleData.roleId0
              },
              {
                label: '风控审核',
                class: 'el-icon-success',
                clickHandler: (index, row) => {
                  this.approveCustomer(index, row)
                },
                conditions: row=> row.m__applicationStatus=='Pending Approval'&&row.t__roleId==this.roleData.roleId1
              },
              {
                label: '查看详情',
                class: 'el-icon-info',
                clickHandler: (index, row) => {
                  this.viewDetail(index, row)
                },
              },
            ]
          }
        ]
      },

      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.search.m.applicationStatus' : this.applicationStatus,
            'xlist.search.m.applicationStatus.op' : 'in',
            'xlist.sort.dataField': 'm.applicationDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getApplyingVehicleMortgageCustomerList()
      },
    },
    mounted() {
      this.getApplyingVehicleMortgageCustomerList()
    },
    methods: {
      getApplyingVehicleMortgageCustomerList: function () {
        xhr.getApplyingVehicleMortgageCustomerList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.listData = res.data
              this.roleData = res.data.variables
            } catch (e) {

            }
          })
      },
      viewDetail: function (index, row) {
        try{
          this.$router.push({
            path: 'Detail?m.applicationId='+row.m__applicationId
          })
        }catch (e) {

        }
      },
      approveCustomer: function (index, row) {
        this.$router.push({
          name: 'CustomerApplyingVehicleMortgageCustomerApprove',
          query: {
            'm.applicationId' : row.m__applicationId
          }
        })
        // this.$confirm('确认审核该用户？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   xhr.updateApproveCustomer({
        //     "c.applicationId": row.c__applicationId,
        //     "a.approvingStatus": 'Approved',
        //     "a.remarks": ""
        //   }, res=>{
        //     try{
        //       if(res.data.status == 'success') {
        //         this.$message({
        //           type: 'success',
        //           message: '操作成功!'
        //         });
        //         this.getApplyingCustomerList()
        //       }
        //     }catch (e) {
        //     }
        //   })
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消操作'
        //   });
        // });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageList.vue